import { render, staticRenderFns } from "./submited.vue?vue&type=template&id=d3289d5e&scoped=true&"
import script from "./submited.vue?vue&type=script&lang=js&"
export * from "./submited.vue?vue&type=script&lang=js&"
import style0 from "./submited.vue?vue&type=style&index=0&id=d3289d5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3289d5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-electron-workbench\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3289d5e')) {
      api.createRecord('d3289d5e', component.options)
    } else {
      api.reload('d3289d5e', component.options)
    }
    module.hot.accept("./submited.vue?vue&type=template&id=d3289d5e&scoped=true&", function () {
      api.rerender('d3289d5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/submited.vue"
export default component.exports